var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2309_3704)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48,
    filter: "url(#filter0_b_2309_3704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 28.4568C8 26.6895 9.43268 25.2568 11.2 25.2568H35.1996C36.9669 25.2568 38.3996 26.6895 38.3996 28.4568V84.457C38.3996 86.2243 36.9669 87.657 35.1996 87.657H11.2C9.43268 87.657 8 86.2243 8 84.457V28.4568Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.3999 32.8C14.3999 32.3582 14.7581 32 15.1999 32H19.9998C20.4416 32 20.7998 32.3582 20.7998 32.8V37.6C20.7998 38.0418 20.4416 38.4 19.9998 38.4H15.1999C14.7581 38.4 14.3999 38.0418 14.3999 37.6V32.8Z",
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3999 44.0002C14.3999 43.5584 14.7581 43.2002 15.1999 43.2002H19.9998C20.4416 43.2002 20.7998 43.5584 20.7998 44.0002V48.8002C20.7998 49.242 20.4416 49.6002 19.9998 49.6002H15.1999C14.7581 49.6002 14.3999 49.242 14.3999 48.8002V44.0002Z",
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3999 55.2004C14.3999 54.7586 14.7581 54.4004 15.1999 54.4004H19.9998C20.4416 54.4004 20.7998 54.7586 20.7998 55.2004V60.0004C20.7998 60.4422 20.4416 60.8004 19.9998 60.8004H15.1999C14.7581 60.8004 14.3999 60.4422 14.3999 60.0004V55.2004Z",
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bi_2309_3704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 15.9998C24 14.2325 25.4327 12.7998 27.2 12.7998H51.1996C52.9669 12.7998 54.3996 14.2325 54.3996 15.9998V72C54.3996 73.7673 52.9669 75.2 51.1996 75.2H27.2C25.4327 75.2 24 73.7673 24 72V15.9998Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.3999 20.343C30.3999 19.9011 30.7581 19.543 31.1999 19.543H35.9998C36.4416 19.543 36.7998 19.9011 36.7998 20.343V25.143C36.7998 25.5848 36.4416 25.943 35.9998 25.943H31.1999C30.7581 25.943 30.3999 25.5848 30.3999 25.143V20.343Z",
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3999 31.5432C30.3999 31.1013 30.7581 30.7432 31.1999 30.7432H35.9998C36.4416 30.7432 36.7998 31.1013 36.7998 31.5432V36.3432C36.7998 36.785 36.4416 37.1432 35.9998 37.1432H31.1999C30.7581 37.1432 30.3999 36.785 30.3999 36.3432V31.5432Z",
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3999 42.7434C30.3999 42.3015 30.7581 41.9434 31.1999 41.9434H35.9998C36.4416 41.9434 36.7998 42.3015 36.7998 42.7434V47.5434C36.7998 47.9852 36.4416 48.3434 35.9998 48.3434H31.1999C30.7581 48.3434 30.3999 47.9852 30.3999 47.5434V42.7434Z",
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3999 53.9426C30.3999 53.5008 30.7581 53.1426 31.1999 53.1426H35.9998C36.4416 53.1426 36.7998 53.5008 36.7998 53.9426V58.7426C36.7998 59.1844 36.4416 59.5426 35.9998 59.5426H31.1999C30.7581 59.5426 30.3999 59.1844 30.3999 58.7426V53.9426Z",
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6001 20.343C41.6001 19.9011 41.9583 19.543 42.4001 19.543H47.2C47.6418 19.543 48 19.9011 48 20.343V25.143C48 25.5848 47.6418 25.943 47.2 25.943H42.4001C41.9583 25.943 41.6001 25.5848 41.6001 25.143V20.343Z",
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6001 31.5432C41.6001 31.1013 41.9583 30.7432 42.4001 30.7432H47.2C47.6418 30.7432 48 31.1013 48 31.5432V36.3432C48 36.785 47.6418 37.1432 47.2 37.1432H42.4001C41.9583 37.1432 41.6001 36.785 41.6001 36.3432V31.5432Z",
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6001 42.7434C41.6001 42.3015 41.9583 41.9434 42.4001 41.9434H47.2C47.6418 41.9434 48 42.3015 48 42.7434V47.5434C48 47.9852 47.6418 48.3434 47.2 48.3434H42.4001C41.9583 48.3434 41.6001 47.9852 41.6001 47.5434V42.7434Z",
    fill: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6001 53.9426C41.6001 53.5008 41.9583 53.1426 42.4001 53.1426H47.2C47.6418 53.1426 48 53.5008 48 53.9426V58.7426C48 59.1844 47.6418 59.5426 47.2 59.5426H42.4001C41.9583 59.5426 41.6001 59.1844 41.6001 58.7426V53.9426Z",
    fill: "#E1E4EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2309_3704",
    x: 4.00002,
    y: 21.2569,
    width: 38.3996,
    height: 70.4003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.99999
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2309_3704"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2309_3704",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_2309_3704",
    x: 16,
    y: 4.7998,
    width: 46.3997,
    height: 78.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2309_3704"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2309_3704",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2309_3704"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2309_3704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLogo);
export default __webpack_public_path__ + "static/media/empty-logo.d6e952567969532f61d887ca900b9de9.svg";
export { ForwardRef as ReactComponent };